// import React, { useState } from "react";
// import "../styles/Dispatches.css";

// const Dispatches = () => {
//   const [dispatches, setDispatches] = useState([
//     {
//       id: "#001",
//       user: "John Doe",
//       type: "Document",
//       status: "Delivered",
//       date: "Sep 8, 2025",
//     },
//     {
//       id: "#002",
//       user: "Jane Smith",
//       type: "Check",
//       status: "Pending",
//       date: "Sep 9, 2025",
//     },
//   ]);

//   const handleNewDispatch = () => {
//     alert("🚀 Open New Dispatch form here!");
//     // later: open modal with form to create new dispatch
//   };

//   const handleView = (id) => {
//     const dispatch = dispatches.find((d) => d.id === id);
//     alert(`📄 Viewing details for ${dispatch.id}\nUser: ${dispatch.user}\nType: ${dispatch.type}\nStatus: ${dispatch.status}\nDate: ${dispatch.date}`);
//     // later: open side panel or modal with details
//   };

//   const handleTrack = (id) => {
//     alert(`📍 Tracking info for ${id}...\n(Currently mocked)`);
//     // later: integrate with tracking API
//   };

//   return (
//     <div className="dispatches-section">
//       <div className="admin-header">
//         <h2>All Dispatches</h2>
//         <button className="btn view" onClick={handleNewDispatch}>
//           + New Dispatch
//         </button>
//       </div>

//       <div className="analytics-cards">
//         <div className="card">
//           <h4>Total Dispatches</h4>
//           <p>{dispatches.length}</p>
//         </div>
//         <div className="card">
//           <h4>Delivered</h4>
//           <p>{dispatches.filter((d) => d.status === "Delivered").length}</p>
//         </div>
//         <div className="card">
//           <h4>Pending</h4>
//           <p>{dispatches.filter((d) => d.status === "Pending").length}</p>
//         </div>
//         <div className="card">
//           <h4>Failed</h4>
//           <p>{dispatches.filter((d) => d.status === "Failed").length}</p>
//         </div>
//       </div>

//       <table className="dispatch-table">
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>User</th>
//             <th>Type</th>
//             <th>Status</th>
//             <th>Date</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {dispatches.map((d) => (
//             <tr key={d.id}>
//               <td>{d.id}</td>
//               <td>{d.user}</td>
//               <td>{d.type}</td>
//               <td>
//                 <span
//                   className={`status ${
//                     d.status === "Delivered"
//                       ? "success"
//                       : d.status === "Pending"
//                       ? "pending"
//                       : "failed"
//                   }`}
//                 >
//                   {d.status}
//                 </span>
//               </td>
//               <td>{d.date}</td>
//               <td>
//                 <button className="btn view" onClick={() => handleView(d.id)}>
//                   View
//                 </button>
//                 <button className="btn track" onClick={() => handleTrack(d.id)}>
//                   Track
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default Dispatches;

import React, { useEffect, useState } from "react";
import "../styles/Dispatches.css";

const API_BASE = process.env.REACT_APP_API_BASE;

const Dispatches = () => {
  const [dispatches, setDispatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchEmail, setSearchEmail] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // ✅ Fetch dispatches from backend
  const fetchAllDispatches = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page,
        limit: 10,
        ...(searchEmail && { email: searchEmail }),
        ...(filter !== "all" && { status: filter }),
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
      });

      const res = await fetch(`${API_BASE}/api/dispatch-log/all?${params.toString()}`);
      const data = await res.json();

      if (data.success && Array.isArray(data.logs)) {
        setDispatches(data.logs);
        setTotalPages(data.totalPages || 1);
      } else {
        console.warn("⚠️ Unexpected API response:", data);
      }
    } catch (err) {
      console.error("❌ Failed to fetch dispatch logs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllDispatches();
  }, [page, filter]);

  // ✅ Search or date filter triggers reload
  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchAllDispatches();
  };

  // ✅ Quick Stats
  const total = dispatches.length;
  const delivered = dispatches.filter((d) => d.status === "Delivered").length;
  const pending = dispatches.filter((d) => d.status === "Pending").length;
  const failed = dispatches.filter((d) => d.status === "Failed").length;

  const handleView = (dispatch) => {
    alert(
      `📄 Details:\nUser: ${dispatch.email}\nCarrier: ${
        dispatch.carrier
      }\nTracking: ${dispatch.carrierTrackingNumber}\nDate: ${new Date(
        dispatch.mailDate || dispatch.createdAt
      ).toLocaleString()}`
    );
  };

  const handleTrack = (dispatch) => {
    if (!dispatch.carrierTrackingUrl)
      return alert("No tracking URL available yet.");
    window.open(dispatch.carrierTrackingUrl, "_blank");
  };

  return (
    <div className="dispatches-section">
      {/* Header + Filters */}
      <div className="admin-header">
        <h2>📦 All Dispatches</h2>

        <form className="filter-row" onSubmit={handleSearch}>
          <input
            type="email"
            placeholder="Search by email..."
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
          />

          <select onChange={(e) => setFilter(e.target.value)} value={filter}>
            <option value="all">All</option>
            <option value="Delivered">Delivered</option>
            <option value="Pending">Pending</option>
            <option value="Failed">Failed</option>
          </select>

          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <button type="submit" className="btn search">
            🔍 Filter
          </button>
        </form>
      </div>

      {/* Stats */}
      <div className="analytics-cards">
        <div className="card">
          <h4>Total Dispatches</h4>
          <p>{total}</p>
        </div>
        <div className="card">
          <h4>Delivered</h4>
          <p>{delivered}</p>
        </div>
        <div className="card">
          <h4>Pending</h4>
          <p>{pending}</p>
        </div>
        <div className="card">
          <h4>Failed</h4>
          <p>{failed}</p>
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading dispatches...</p>
      ) : dispatches.length === 0 ? (
        <p>No dispatches found.</p>
      ) : (
        <>
          <table className="dispatch-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Files</th>
                <th>Carrier</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {dispatches.map((d, i) => (
                <tr key={d._id || i}>
                  <td>{d.cjetTrackingId || "—"}</td>
                  <td>{d.email || "N/A"}</td>
                  <td>
                    {Array.isArray(d.files)
                      ? d.files.map((f) => f.name).join(", ")
                      : "No files"}
                  </td>
                  <td>{d.carrier || "—"}</td>
                  <td>
                    <span
                      className={`status ${
                        d.status === "Delivered"
                          ? "success"
                          : d.status === "Pending"
                          ? "pending"
                          : "failed"
                      }`}
                    >
                      {d.status || "Pending"}
                    </span>
                  </td>
                  <td>
                    {new Date(d.mailDate || d.createdAt || Date.now()).toLocaleDateString()}
                  </td>
                  <td>
                    <button className="btn view" onClick={() => handleView(d)}>
                      View
                    </button>
                    <button className="btn track" onClick={() => handleTrack(d)}>
                      Track
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="pagination-controls">
            <button
              disabled={page <= 1}
              onClick={() => setPage((p) => p - 1)}
              className="btn"
            >
              ⬅ Prev
            </button>
            <span>
              Page {page} of {totalPages}
            </span>
            <button
              disabled={page >= totalPages}
              onClick={() => setPage((p) => p + 1)}
              className="btn"
            >
              Next ➡
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Dispatches;